<template>
  <div>
    <div class="primary-panel--heading">
      <h3 class="h3">Enter new password</h3>
    </div>

    <!--password -->
    <div class="inputs-grid--full">
      <div
        data-input-module="primary-input"
        class="form-group primary-input primary-input---with-icon"
        v-bind:class="{ 'primary-input---with-error' : errors.has('passwordas') }"
      >
        <input
          v-model="password"
          class="primary-input--field"
          id="passwordI"
          name="passwordas"
          ref="passwordas"
          type="password"
          value
          onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);"
          data-toggle="blur"
          v-validate="'required|min:6|max:20'"
          data-vv-as="Password"
        >
        <label class="primary-input--label" for="passwordas">Enter password</label>
        <div class="primary-input--label-line-break"></div>
        <div class="primary-input--decoration"></div>
        <div class="primary-input--suffix">
          <div class="primary-input--password-eye" onclick="window.showPassword(this)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="11"
              height="7"
              viewBox="0 0 11 7"
              class
            >
              <path
                transform="translate(-1190 -502)"
                d="M1201 505.5a6.15 6.15 0 0 1-5.5 3.5 6.15 6.15 0 0 1-5.5-3.5 6.15 6.15 0 0 1 5.5-3.5c2.4 0 4.48 1.42 5.5 3.5zm-2.92-1.72a2.78 2.78 0 0 1-2.58 3.76 2.78 2.78 0 0 1-2.58-3.76 5.02 5.02 0 0 0-1.74 1.72c.41.66.96 1.22 1.6 1.64a4.97 4.97 0 0 0 5.43 0c.65-.42 1.2-.98 1.6-1.64a5.28 5.28 0 0 0-1.73-1.72zm-3.61-.45c-.57 0-1.03.47-1.03 1.05 0 .58.46 1.05 1.03 1.05.57 0 1.03-.47 1.03-1.05 0-.58-.46-1.05-1.03-1.05z"
              ></path>
            </svg>
          </div>
        </div>
          <div v-show="errors.has('passwordas')" class="primary-input--error">
            <div class="primary-input--error-text">Please enter password</div>
            <div class="primary-input--error-icon"></div>
          </div>
        <div class="primary-input--icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            class
          >
            <path
              transform="translate(-130 -333)"
              d="M139 333a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm2.25-8.53c.41 0 .75.34.75.76v3.8c0 .43-.34.77-.75.77h-4.5a.76.76 0 0 1-.75-.76v-3.81c0-.42.34-.76.75-.76h.38v-.77c0-1.05.84-1.9 1.87-1.9a1.9 1.9 0 0 1 1.88 1.9v.77zm-3.41-.77v.77h2.32v-.77c0-.65-.52-1.18-1.16-1.18-.64 0-1.16.53-1.16 1.18z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <!--./password -->
    <!--repeat password -->
    <div class="inputs-grid--full">
      <div
        data-input-module="primary-input"
        class="form-group primary-input primary-input---with-icon"
        v-bind:class="{ 'primary-input---with-error' : errors.has('passwordRep') }"
      >
        <input
          v-model="passwordRepeat"
          class="primary-input--field"
          id="passwordR"
          name="passwordRep"
          type="password"
          value
          onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);"
          data-toggle="blur"
          v-validate="'required|confirmed:passwordas'" 
        >
        <label class="primary-input--label" for="passwordRep">Repeat password</label>
        <div class="primary-input--label-line-break"></div>
        <div class="primary-input--decoration"></div>
        <div class="primary-input--suffix">
          <div class="primary-input--password-eye" onclick="window.showPassword(this)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="11"
              height="7"
              viewBox="0 0 11 7"
            >
              <path
                transform="translate(-1190 -502)"
                d="M1201 505.5a6.15 6.15 0 0 1-5.5 3.5 6.15 6.15 0 0 1-5.5-3.5 6.15 6.15 0 0 1 5.5-3.5c2.4 0 4.48 1.42 5.5 3.5zm-2.92-1.72a2.78 2.78 0 0 1-2.58 3.76 2.78 2.78 0 0 1-2.58-3.76 5.02 5.02 0 0 0-1.74 1.72c.41.66.96 1.22 1.6 1.64a4.97 4.97 0 0 0 5.43 0c.65-.42 1.2-.98 1.6-1.64a5.28 5.28 0 0 0-1.73-1.72zm-3.61-.45c-.57 0-1.03.47-1.03 1.05 0 .58.46 1.05 1.03 1.05.57 0 1.03-.47 1.03-1.05 0-.58-.46-1.05-1.03-1.05z"
              ></path>
            </svg>
          </div>
        </div>
        <div v-show="errors.has('passwordRep')" class="primary-input--error">
            <div class="primary-input--error-text">Passwords must match</div>
            <div class="primary-input--error-icon"></div>
          </div>
        <div class="primary-input--icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <path
              transform="translate(-130 -333)"
              d="M139 333a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm2.25-8.53c.41 0 .75.34.75.76v3.8c0 .43-.34.77-.75.77h-4.5a.76.76 0 0 1-.75-.76v-3.81c0-.42.34-.76.75-.76h.38v-.77c0-1.05.84-1.9 1.87-1.9a1.9 1.9 0 0 1 1.88 1.9v.77zm-3.41-.77v.77h2.32v-.77c0-.65-.52-1.18-1.16-1.18-.64 0-1.16.53-1.16 1.18z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <!--./repeat password -->
    <form>
      <div class="text-center mb-3 modal-reset">
        <button type="button" v-on:click="resetPassword" class="btn btn-primary block">Change</button>
      </div>
    </form>
  </div>
</template>
<script>
import * as api from "../modules/api.js";

var me;
export default {
  data() {
    return {
      password: "",
      passwordRepeat: ""
    };
  },
  methods: {
    resetPassword: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.$store.dispatch("newpassword", {
            password: this.password
          });
        }
      });
    }
  }
};
</script>